import { INotificationSetting, IResponseNotificationSetting } from '../types/notifications';

export const notificationSettingCast = (data: IResponseNotificationSetting): INotificationSetting => {
  return {
    id: data.id,
    subject: { en: data.subject, ar: data.subject_ar },
    message: { en: data.message, ar: data.message_ar },
    deliveryMethod: data.delivery_method,
    event: data.order_status,
    status: data.auto,
  };
};

export const getNotificationSettingParams = (data: INotificationSetting) => {
  return {
    order_status: data.event,
    delivery_method: data.deliveryMethod,
    subject: data.subject.en,
    subject_ar: data.subject.ar,
    message: data.message.en,
    message_ar: data.message.ar,
    status: 0,
  };
};
